import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const WhatsAppButton = () => {
  const [phoneNumber, setPhoneNumber] = useState('5543996963570');
  const message = 'Olá! Gostaria de atendimento especializado da MULTICELL.';
  
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${API_URL}/api/public/settings`);
      if (response.ok) {
        const data = await response.json();
        if (data?.footer?.whatsapp) {
          setPhoneNumber(data.footer.whatsapp);
        }
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    /* Container fixo no canto inferior direito - sem animações que causem reflow */
    <div 
      className="fixed bottom-6 right-6 z-50"
      style={{ 
        /* Valores fixos para evitar qualquer recálculo */
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        /* Força GPU compositing para evitar jitter */
        willChange: 'auto',
        transform: 'translateZ(0)'
      }}
    >
      {/* Badge ONLINE - posição absoluta relativa ao container fixo */}
      <div 
        className="absolute -top-2 -left-2 z-10 bg-[#25D366] text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-md"
        style={{
          /* Sem animações - completamente estático */
          animation: 'none',
          transition: 'none'
        }}
      >
        ONLINE
      </div>

      {/* Botão Principal */}
      <button
        onClick={handleClick}
        className="relative bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.5)] hover:shadow-[0_6px_25px_rgba(37,211,102,0.7)] transition-shadow duration-300 group"
        data-testid="whatsapp-button"
        aria-label="Atendimento Imediato via WhatsApp"
        style={{
          /* Evita animações de transform no botão principal */
          transform: 'none'
        }}
      >
        {/* Círculo com ícone */}
        <div className="p-4">
          <Phone className="h-7 w-7" />
        </div>
        
        {/* Pulse Ring - só no hover, sem animação contínua */}
        <span 
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-0 group-hover:opacity-30 transition-opacity duration-300"
          style={{ animation: 'none' }}
        />

        {/* Tooltip/Label - aparece no hover */}
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#1C1C1F] border border-[#25D366] text-[#EAEAEA] px-4 py-2 rounded-lg font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg text-sm pointer-events-none">
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-[#25D366] rounded-full" />
            Atendimento Imediato
          </div>
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;
